import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { signupFromValidatorUser } from "../../../services/validatior/formValidator/authValidator";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import GoogleAutoCompleteComp from "../../../components/common/GoogleAutoComplete/GoogleAutoCompleteComp";
import { useDispatch, useSelector } from "react-redux";
import { signUp } from "../../../redux/reducers/authSlice";
import { getPostalSectors } from "../../../redux/reducers/postalSectorsSlice";
import DropdownInput from "../../../components/common/DropdownInput";
import { clearDatahandling } from "../../../utils/clearDataHandling";
import OneMapField from "../../../components/common/OneMapField/OneMapField";
import { toSentenceCase } from "../../../utils/commonFuncs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { TextField } from "@mui/material";
const SignUp = () => {
  const [sortedLocations, setSortedLocations] = useState([])
  const { postalData
  } = useSelector((state) => state.poastalSectorsLists);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isPwdShown, setIsPwdShown] = useState(true);
  const [locations, setLocations] = useState({
    address: '',
    country: '',
    postalCode: '',
    isPrimary: true,
    isActive: true,
    location: {
      type: "Point",
      coordinates: [""]
    }
  })

  const signUpFormik = useFormik({
    initialValues: signupFromValidatorUser.initialValues,
    validationSchema: signupFromValidatorUser.validationSchema,
    onSubmit: (data) => {
      let fullName = `${data.fname}` + " " + `${data.lname}`;
      let bodyData = {
        ...data, locations: [{ ...locations, title: data?.addressName, unitNo: data?.unitNo, generalLocation: locations?.generalLocation ? locations?.generalLocation : sortedLocations[0]?.generalLocation }], name: fullName
      }
      delete bodyData.generalLocation
      delete bodyData.addressName
      delete bodyData.unitNo
      delete bodyData.confirmEmail
      delete bodyData.postalCode
      delete bodyData.country


      dispatch(signUp({
        apiData: bodyData,
        navigate: navigate,
        signUpFormik: signUpFormik,
        dispatch: dispatch,
        creatingOrder: false
      }))

    }
  })
  const handleAddress = (addressObj, address) => {
    if (addressObj?.postal_code) {
      setLocations({
        ...locations,
        address: address?.label.replace('Singapore', ''),
        country: addressObj?.country,
        postalCode: addressObj?.postal_code,
        isPrimary: true,
        isActive: true,
        location: {
          type: "Point",
          coordinates: [Number(addressObj?.lng), Number(addressObj?.lat)]
        }
      })
      signUpFormik.setFieldValue("country", addressObj?.country)
      signUpFormik.setFieldValue("postalCode", addressObj?.postal_code)

      setSortedLocations(postalData.filter(item => item?.postalCode == addressObj?.postal_code.slice(0, 2)))
    }
    else if (!addressObj?.postal_code && address?.label) {
      toast.error('Try to search more precisely')
    }
  }

  const handleInputChangeForPhone = (e) => {
    e.target.value = e.target.value.replace(/\D/g, ''); // Filter out non-digit characters
    signUpFormik.handleChange(e); // Call Formik's handleChange with the modified event
  };

  const handleChangeAddress = (e) => {
    setLocations({ ...locations, address: e.target.value })
  }

  const handleOneMapData = (response) => {
    if (response) {
      setLocations({
        ...locations,
        address: toSentenceCase(`${response?.BLK_NO !== 'NIL' ? response?.BLK_NO : ''} ` + `${response?.ROAD_NAME !== 'NIL' ? response?.ROAD_NAME : ''}`),
        country: 'Singapore',

        postalCode: response.POSTAL,
        isPrimary: true,
        isActive: true,
        location: {
          type: "Point",
          coordinates: [Number(Number(response.LONGITUDE).toFixed(6)), Number(Number(response.LATITUDE).toFixed(6))]
        }
      })
      signUpFormik.setFieldValue("country", 'Singapore')
      signUpFormik.setFieldValue("postalCode", response?.POSTAL)
      signUpFormik.setFieldValue('unitNo', toSentenceCase(`${response?.BUILDING !== 'NIL' ? response?.BUILDING : ''}`))
      setSortedLocations(postalData.filter(item => item?.postalCode == response.POSTAL.slice(0, 2)))
    }
    else {
      setLocations({
        ...locations,
        address: '',
        country: '',
        generalLocation: '',
        isActive: true,
        postalCode: '',
        location: {
          type: "Point",
          coordinates: []
        }
      })
      signUpFormik.setFieldValue("country", '')
      signUpFormik.setFieldValue("postalCode", '')
      signUpFormik.setFieldValue('unitNo', ``)
    }
  }

  useEffect(() => {
    dispatch(getPostalSectors())
  }, [])
  useEffect(() => {
    clearDatahandling(dispatch)

  }, [])

  return (
    <>
      <div className=" auth-signup max-720">
        <div className="cre-banner">Create an Account</div>
        {/* <h6>Create With Your Social accout</h6>
        <div className="divider my-4 text-center">
          <div className="d-flex justify-content-center">
            <ul className='list-unstyled d-flex'>
              <li className="btn btn-icon  btn-label-facebook me-3">
                <FontAwesomeIcon icon={faFacebookF} />
              </li>

              <li className="btn btn-icon btn-label-google-plus me-3">
                <FontAwesomeIcon icon={faGoogle} />
              </li>
            </ul>
          </div>
          <div className="divider-text w-100">or</div>
        </div> */}

        {/* form */}
        <form onSubmit={signUpFormik.handleSubmit}>
          <div className="acc-info mb-4">
            <p>Account Information</p>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="">First Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    id="fname"
                    name="fname"
                    placeholder="Your First Name"
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.fname}
                  />
                  <p className='form-error-message'>{signUpFormik.touched.fname &&
                    signUpFormik.errors.fname}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="">Last Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    id="lname"
                    name="lname"
                    placeholder="Your Last Name"
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.lname}
                  />
                  <p className='form-error-message'>{signUpFormik.touched.lname &&
                    signUpFormik.errors.lname}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    {" "}
                    Email Address *{" "}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.email}
                    placeholder="Enter your email"
                  />
                  <p className='form-error-message'>{signUpFormik.touched.email &&
                    signUpFormik.errors.email}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    {" "}
                    Confirm Email Address *{" "}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="confirmEmail"
                    id="confirmEmail"
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.confirmEmail}
                    placeholder="Enter your email"
                  />
                  <p className='form-error-message'>{signUpFormik.touched.confirmEmail &&
                    signUpFormik.errors.confirmEmail}</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group international-location-w">
                  <label htmlFor="email" className="form-label">
                    Mobile Number *
                  </label>
                  <div className="international-location">
                    <select
                      aria-label="Default select example"
                      className="form-select"
                      name="countryCode"
                      id="countryCode"

                      onChange={signUpFormik.handleChange}
                      value={signUpFormik.values.countryCode}
                    >
                      <option value="65">+65</option>
                      {/* <option value="1">+65</option>
                      <option value="1">+65</option> */}
                    </select>
                    <p className='form-error-message'>{signUpFormik.touched.countryCode &&
                      signUpFormik.errors.countryCode}</p>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    name="phoneNumber"
                    maxLength={25}
                    onChange={handleInputChangeForPhone}
                    value={signUpFormik.values.phoneNumber}
                  />
                  <p className='form-error-message'>{signUpFormik.touched.phoneNumber &&
                    signUpFormik.errors.phoneNumber}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  {/* <label htmlFor="email" className="form-label">
                    {" "}
                    Password{" "}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="confirmEmail"
                    id="confirmEmail"
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.confirmEmail}
                    placeholder="Enter your email"
                  />
                  <p className='form-error-message'>{signUpFormik.touched.confirmEmail &&
                    signUpFormik.errors.confirmEmail}</p> */}
                  <div className="mb-3 form-password-toggle">
                    <div className="position-relative">
                      <label className="form-label" htmlFor="password">
                        Password *
                      </label>
                      <div className="input-group input-group-merge ">
                        <input
                          type={isPwdShown ? "password" : "text"}
                          id="password"
                          className="form-control"
                          name='password'
                          value={signUpFormik?.values.password}
                          onChange={signUpFormik.handleChange}
                          placeholder=""
                          aria-describedby="password"
                        />

                        <span className="input-group-text cursor-pointer">
                          <FontAwesomeIcon
                            icon={
                              isPwdShown ?
                                icon({ name: "eye-slash" })
                                : icon({ name: "eye" })
                            }
                            onClick={() => setIsPwdShown(!isPwdShown)}
                          />
                        </span>

                      </div>

                    </div>
                    <p className='form-error-message'>{signUpFormik.touched.password &&
                      signUpFormik.errors.password}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Date of birth</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      sx={{ width: '100%' }}
                      format='DD/MM/YYYY'
                      onChange={(newValue) =>
                        signUpFormik.setFieldValue('dob', new Date(newValue).toISOString())
                      }
                      value={dayjs(signUpFormik.values.dob)}
                      renderInput={(params) => (
                        <TextField {...params} className={`!p-0`} />
                      )}
                    />
                  </LocalizationProvider>
                  <p className='form-error-message'>{signUpFormik.touched.dob &&
                    signUpFormik.errors.dob}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  {/* <label htmlFor="email" className="form-label">
                    Your Property Type
                  </label>

                  <select
                    aria-label="Default select example"
                    className="form-select"
                    name="property_type"
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.property_type}
                  >
                    <option value="HDB">HDB</option>
                    <option value="Condo">Condo</option>
                    <option value="Landed">Landed</option>
                  </select> */}
                  <DropdownInput
                    label={"Your Property Type"}
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.property_type}
                    name="property_type"
                    id="property_type"
                    options={[
                      { value: "HDB", option: "HDB" },
                      { value: "Condo", option: "Condo" },
                      { value: "Landed", option: "Landed" },
                    ]}
                  />
                  <p className='form-error-message'>{signUpFormik.touched.property_type &&
                    signUpFormik.errors.property_type}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="acc-info">
            <p>Your Address</p>
            {!locations?.postalCode && <span className={`pincode-txt`}>* Please add valid pincode first to get address line 1</span>}
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  {/* <input
                    type="text"
                    className="form-control"
                    id="tex1"
                    name="text1"
                    placeholder="Address Line 1"
                  /> */}
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      disabled={!locations?.postalCode}
                      className="form-control"
                      onChange={handleChangeAddress}
                      value={locations?.address}
                      placeholder="7030 Ang Mo Kio Ave 5"
                    />
                    <p className='form-error-message'>
                      {!locations?.postalCode ? 'Add Postalcode first' : !locations?.address ?
                        "This is required field" : ''}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Floor/unit number/Building name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="unitNo"
                    name="unitNo"
                    placeholder="#09-85 Northstar @ AMK"
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.unitNo}
                  />
                  {/* <p className='form-error-message'>{signUpFormik.touched.unitNo &&
                    signUpFormik.errors.unitNo}</p> */}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <OneMapField
                    label={'Postal Code'}
                    type="number"
                    handleOnChange={handleOneMapData}
                    name="postalCode"
                    id="postalCode"
                    value={locations.postalCode}
                  />
                  <p className='form-error-message'>
                    {signUpFormik.touched.postalCode &&
                      signUpFormik.errors.postalCode}
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Country
                  </label>
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    id="country"
                    name="country"
                    placeholder="Enter Country"
                    value={locations?.country ? "Singapore" : ""}
                  />
                  <p className='form-error-message'>{signUpFormik.touched.country &&
                    signUpFormik.errors.country}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Name of address *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="addressName"
                    name="addressName"
                    placeholder="My Home"
                    onChange={signUpFormik.handleChange}
                    value={signUpFormik.values.addressName}
                  />
                  <p className='form-error-message'>{signUpFormik.touched.addressName &&
                    signUpFormik.errors.addressName}</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Location
                  </label>

                  <select
                    aria-label="Default select example"
                    className="form-select"
                    name="generalLocation"
                    id="generalLocation"
                    disabled={!locations?.address}
                    onChange={(e) => {
                      setLocations({
                        ...locations,
                        generalLocation: e.target.value,
                      });

                    }}
                  >
                    {sortedLocations.map((item) => {
                      return (
                        <option value={item?.generalLocation}>
                          {item?.generalLocation}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="acc-info">
            <p>Notification</p>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="terms-conditions"
                name="terms"
                onChange={(e) => signUpFormik.setFieldValue('isNotify', e.target.checked)}
              />
              <label
                className="form-check-label"
                htmlFor="terms-conditions"
              >
                Keep Me Updated with news, special promotions via email or sms
              </label>
            </div>
          </div>
          <div className="sign-bottom">
            <div className="text-text">By signing up, you agree to and verify you have read our <a href="https://www.oneheartcleaning.com.sg/terms" target="blank" style={{ cursor: "pointer" }} className="colour-red">Terms and Conditions</a> and <a href="https://www.oneheartcleaning.com.sg/privacy" target="blank" style={{ cursor: "pointer" }} className="colour-red">Privacy Policy</a>.</div>
            <div className="sign-up-btn">
              <button type="submit" className="btn rounded-pill">Sign Up</button>
            </div>

          </div>
        </form>
      </div>
    </>
  );
};

export default SignUp;
